/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Share_Folder_FromInputs */

const cs_automation_share_folder_from = /** @type {(inputs: Automation_Share_Folder_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sdílet složku z`)
};

const en_automation_share_folder_from = /** @type {(inputs: Automation_Share_Folder_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share folder of`)
};

/**
* | output |
* | --- |
* | "Share folder of" |
*
* @param {Automation_Share_Folder_FromInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_share_folder_from = /** @type {((inputs?: Automation_Share_Folder_FromInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Share_Folder_FromInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_share_folder_from(inputs)
	return cs_automation_share_folder_from(inputs)
});